import React, {useState, useEffect} from 'react';
import Select, { components } from 'react-select';
import { withTranslation } from 'react-i18next';
import "./selectField.scss";
import AsyncSelect from 'react-select/async';
import {Option} from "../../../models/Option";
import i18next from "i18next";
import BaseField from './baseField';

const CustomOption = (props: any) => {
    const handleChange = () => {
        const newValue = !props.isSelected;
        const newSelectedOptions = newValue
            ? [...props.selectProps.value, props.data]
            : props.selectProps.value.filter((option: any) => option.value !== props.data.value);

        props.selectProps.onChange(newSelectedOptions);
    };

    return (
        <components.Option {...props}>
            <input  hidden={props.data.value === "filterToViewMore"||!props.selectProps.isMulti}
                type="checkbox"
                className='w-10'
                checked={props.isSelected}
                onChange={handleChange}
            />{" "}
            {props.data.value === "filterToViewMore"?<span style={{color:"gray"}}>{props.label}</span>:props.label}
        </components.Option>
    );
};



const CustomMultiValue = (props: any) => {
    const { index, getValue } = props;
    const maxToShow = 2;
    const overflow = getValue().length - maxToShow;

    if (index < maxToShow) {
        return <components.MultiValue {...props} />;
    }

    if (index === maxToShow) {
        return (
            <components.MultiValue {...props}>
                + {overflow}
            </components.MultiValue>
        );
    }

    return null;
};



const MultiSelectField = ({ attr, label, options, selectedOptions, setSelectedOptions,multiSelect }: {attr:any, label:any, options:Option[], selectedOptions:any, setSelectedOptions:any,multiSelect:boolean}) => {
    const [defaultOptions, setDefaultOptions] = useState<Option[]>([]);
    const selectSinglePlaceHolder: string= i18next.t("common.action.select");

    const handleChange = (selected: any) => {
        if(multiSelect){
            const values = selected ? selected.map((option: any) => option.value) : [];
            setSelectedOptions(values);
        }else{
            const values = selected ? [selected.value] : [];
            setSelectedOptions(values);
        }
    };

    useEffect(() => {
        // Update defaultOptions when options change
        promiseOptions("").then((res)=>{
        setDefaultOptions(res);
        });
    }, [options]);

    const selectedValues = selectedOptions || []; 
    const customStyles = {
        option: (provided:any) => ({
            ...provided,
            display: 'inline-flex !important',
        }),
    };
    
    const promiseOptions = (inputValue: string) =>
        new Promise<Option[]>((resolve) => {
            var res=[];
            for(var i in options){
                if((options[i].label+"").toUpperCase().indexOf(inputValue.toUpperCase())==0)
                    res.push(options[i]);
                if(res.length>50){
                    res.push({label:i18next.t("filterToViewMore"),value:"filterToViewMore"});
                    break;
                }
            }
            resolve(res);

    });
    const getClassOfTypeMultiselect = () =>{
        let value= (!multiSelect ? "container-multiselect singleSelect" : "container-multiselect");
        return value;
    }

    return (
        <BaseField attr={attr} label={label} value={selectedValues}>
            <div className={getClassOfTypeMultiselect()}>
                <AsyncSelect loadOptions={promiseOptions}
                    defaultOptions={defaultOptions}
                    hideSelectedOptions={false}
                    isMulti={multiSelect}
                    isSearchable
                    closeMenuOnSelect={!multiSelect}
                    placeholder={!multiSelect && selectSinglePlaceHolder}
                    onChange={handleChange}
                    value={options.filter((option: any) => selectedValues.includes(option.value))}
                    components={{ Option: CustomOption, MultiValue: CustomMultiValue }}
                    inputId={attr}
                    className={`w-100`}
                    styles={customStyles}
                />
                {/*
                <Select
                    hideSelectedOptions={false}
                    options={options}
                    isMulti
                    isSearchable
                    closeMenuOnSelect={false}
                    placeholder={label}
                    onChange={handleChange}
                    value={options.filter((option: any) => selectedValues.includes(option.value))}
                    components={{ Option: CustomOption, MultiValue: CustomMultiValue }}
                    inputId={attr}
                    className="w-100"
                />
                */}
            </div>
        </BaseField>

        );
};

export default withTranslation()(MultiSelectField);

